


























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CouponCardIcon extends Vue {
  @Prop({ default: '130' }) readonly width?: string;
  @Prop({ default: '43' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
